//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  setup() {
    const items = [
      { header: 'Today' },
      {
        avatar: require('@/assets/images/avatars/1.png'),
        title: 'Brunch this weekend?',
        subtitle: {
          name: 'Ali Connors',
          desc: "I'll be in your neighborhood doing errands this weekend. Do you want to hang out?",
        },
      },
      { divider: true, inset: true },
      {
        avatar: require('@/assets/images/avatars/3.png'),
        title: 'Summer BBQ ',
        subtitle: {
          name: 'to Alex, Scott, Jennifer',
          desc: "Wish I could come, but I'm out of town this weekend.",
        },
      },
      { divider: true, inset: true },
      {
        avatar: require('@/assets/images/avatars/2.png'),
        title: 'Oui oui',
        subtitle: {
          name: 'Sandra Adams',
          desc: 'Do you have Paris recommendations? Have you ever been?',
        },
      },
    ]

    return { items }
  },
}
